// Path: ./src/app/components/SmallDealImgCard/index.tsx
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import IconButton from "@mui/material/IconButton";
import { MouseEventHandler } from "react";
import { CancelButton, EditButton, TagButton, Image, Card, Container } from "./styled";
import { PermissionComponentWrapper } from "../PermissionComponentWrapper";

interface Props {
  /**
   * Click event handler for cancel/remove image.
   * Invoked when the cancel button is clicked to cancel/remove the image.
   */
  cancelButtonClick?: MouseEventHandler<HTMLButtonElement>;

  /**
   * Click event handler for edit image.
   * Invoked when the edit button is clicked to edit the image.
   */
  editButtonClick?: MouseEventHandler<HTMLButtonElement>;

  /**
   * Click event handler for tag edit.
   * Invoked when the tag button is clicked to edit image tags.
   */
  tagButtonClick?: MouseEventHandler<HTMLButtonElement>;

  imageSrc?: string;
}
export const SmallDealImgCard = ({
  cancelButtonClick,
  editButtonClick,
  tagButtonClick,
  imageSrc,
}: Props) => {
  return (
    <Container data-testid={`smallUploadedImage`}>
      <Card>
        <Image src={imageSrc} />
      </Card>
      <CancelButton>
        <IconButton
          sx={{ color: "red" }}
          onClick={cancelButtonClick}
          data-testid={`smallUploadedImage-cancel`}
        >
          <CancelIcon style={{ fontSize: 20 }} />
        </IconButton>
      </CancelButton>
      {editButtonClick && (
        <EditButton>
          <IconButton
            sx={{
              color: "white",
              backgroundColor: "#ff813a",
              "&:hover": {
                backgroundColor: "#ff6520",
              },
            }}
            onClick={editButtonClick}
            data-testid={`smallUploadedImage-edit`}
            size="small"
          >
            <EditIcon style={{ fontSize: 16 }} />
          </IconButton>
        </EditButton>
      )}
      {tagButtonClick && (
        <PermissionComponentWrapper
          requiredPermission={["update"]}
          requiredPermissionGroup={["imageTag"]}
          wrapperCss={`
          display:block;
          margin-bottom:5px;
          margin-top: 5px;
          `}
        >
        <TagButton>
          <IconButton
            sx={{
              color: "white",
              backgroundColor: "#f58220",
              "&:hover": {
                backgroundColor: "#d96e10",
              },
            }}
            onClick={tagButtonClick}
            data-testid={`smallUploadedImage-tag`}
            size="small"
          >
            <LocalOfferIcon style={{ fontSize: 16 }} />
          </IconButton>
        </TagButton>
        </PermissionComponentWrapper>
      )}
    </Container>
  );
};
